/**
 * Constants and configuration objects for ScannerConfigurationForm
 */

/**
 * Compatibility mapping between target systems and their supported authentication methods
 */
export const TARGET_SYSTEM_AUTH_COMPATIBILITY = {
  'amazon-bedrock': ['iam-access-key', 'oauth'],
  'azure-openai': ['oauth'],
  'google-gemini': ['oauth']
};

/**
 * Configuration for authentication method fields
 */
export const AUTH_METHOD_FIELDS = {
  'iam-access-key': ['accessKeyId', 'secretAccessKey', 'awsRegion'],
  oauth: [
    'clientId',
    'clientSecret',
    'authorizationServerURL',
    'tokenEndpointURL',
    'redirectURI',
    'scope'
  ]
};

/**
 * Auth method field configurations with default values.
 * Each key maps to the fields required for that authentication type.
 */
export const AUTH_FIELD_DEFAULTS = {
  'iam-access-key': {
    accessKeyId: '',
    secretAccessKey: '',
    awsRegion: ''
  },
  oauth: {
    clientId: '',
    clientSecret: '',
    authorizationServerURL: '',
    tokenEndpointURL: '',
    redirectURI: '',
    scope: ''
  }
};

/**
 * Base connection fields that are common across all authentication methods
 */
export const BASE_CONNECTION_FIELDS = ['targetSystem', 'authMethod'];

/**
 * Target system options for the select dropdown
 */
export const TARGET_SYSTEM_OPTIONS = [
  { label: 'Amazon Bedrock', value: 'amazon-bedrock', disabled: false },
  { label: 'Azure OpenAI', value: 'azure-openai', disabled: true },
  { label: 'Google Gemini', value: 'google-gemini', disabled: true }
];

/**
 * All available authentication methods
 */
export const ALL_AUTH_METHODS = [
  { label: 'IAM Access Key', value: 'iam-access-key' },
  { label: 'OAuth', value: 'oauth' }
];

/**
 * Run time options (24-hour format, 0-23)
 */
export const RUN_TIME_OPTIONS = Array.from({ length: 24 }, (_, i) => ({
  label: `${i}`,
  value: `${i}`
}));

/**
 * Interval unit options for custom schedule
 */
export const INTERVAL_UNIT_OPTIONS = [
  { label: 'days', value: 'days' },
  { label: 'weeks', value: 'weeks' },
  { label: 'months', value: 'months' }
];

/**
 * Week days for custom schedule
 */
export const WEEK_DAYS = [
  { label: 'M', value: 'M' },
  { label: 'T', value: 'T' },
  { label: 'W', value: 'W' },
  { label: 'Th', value: 'Th' },
  { label: 'F', value: 'F' },
  { label: 'S', value: 'S' },
  { label: 'Su', value: 'Su' }
];

/**
 * Day name mapping for schedule labels
 */
export const DAY_NAME_MAP = {
  M: 'Monday',
  T: 'Tuesday',
  W: 'Wednesday',
  Th: 'Thursday',
  F: 'Friday',
  S: 'Saturday',
  Su: 'Sunday'
};

/**
 * Default form values
 */
export const DEFAULT_FORM_VALUES = {
  runFrequency: 'Daily',
  runTime: '2',
  syncReview: 'auto-resolve',
  emailNotificationsEnabled: false,
  recipientEmails: []
};

/**
 * Default custom schedule state
 */
export const DEFAULT_CUSTOM_SCHEDULE = {
  intervalNumber: 3,
  intervalUnit: 'days',
  repeatDays: [],
  monthDay: 1
};
